import {inject, injectable} from "inversify";
import {ConfigRepository} from "@/modules/base/services/ConfigRepository";
import {Player, Team} from "@/modules/team/entity";
import {LaneType} from "@/modules/match/services/live-match-handlers/LaneBasedGoalsHandler";
import {LineupEnum, PositionEnum} from "@/modules/base/enums";
import {FormationEnum} from "@/modules/team/enums";
import EffectiveLineupSkillCalculator from "@/modules/team/services/EffectiveLineupSkillCalculator";

@injectable()
export default class LaneCalculator {
  static positionLaneMapping: PositionEnum[][] = [
    [PositionEnum.GK, PositionEnum.CD],
    [PositionEnum.LD, PositionEnum.RD, PositionEnum.DM],
    [PositionEnum.CM, PositionEnum.LM, PositionEnum.RM],
    [PositionEnum.OM, PositionEnum.LW, PositionEnum.RW],
    [PositionEnum.FW],
  ];

  constructor(
    @inject(ConfigRepository) private configRepository: ConfigRepository,
    @inject(EffectiveLineupSkillCalculator) private effectiveLineupSkillCalculator: EffectiveLineupSkillCalculator,
  ) {
  }

  private formationToPosition(formation: FormationEnum, lineup: LineupEnum): PositionEnum {
    const definition = this.configRepository.get('formations.all')[formation];

    return definition[lineup].position;
  }

  calculate(team: Team, suspendedPlayerId: number[] = []): LaneType[] {
    return LaneCalculator.positionLaneMapping.map((positions: PositionEnum[]) => {
      const players = collect<Player>(team.players)
        .filter(p => p.lineup !== null)
        .filter(p => !suspendedPlayerId.includes(p.id))
        .filter(p => positions.includes(this.formationToPosition(team.formation, p.lineup!)));

      return {
        players,
        effectiveSkill: this.effectiveLineupSkillCalculator.calculateLinedupSkillByTeam(
          team,
          players.toArray() as Player[]
        )
      };
    });
  }
}
